import React, { useContext, useEffect, useState } from 'react';
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Input,
} from 'reactstrap';
import { ReactComponent as Settinglines } from "../../../images/settinglines.svg";
import { ReactComponent as SettinglinesGold } from "../../../images/settinglinesGold.svg";
import Service from '../../../services';
import { WatchlistItem } from '../../../models/WatchListModel';
import { AxiosError, AxiosResponse } from 'axios';
import { catchError } from '../../../utils/Utils';
import { response } from 'express';
import { BankUserContext } from '../../../bankUserContext';
import { toast } from 'react-toastify';
import FinSpinner from '../../../commonfields/FinSpinner';
import { update } from 'lodash';


function Focus() {
  const watchListFilter = [
    "edit In Focus",
    "sort: a to z",
    "sort: z to a",
    "sort: newest to oldest",
    "sort: oldest to newest"
  ]
  const [editMode, setEditMode] = useState(false);
  const [filterToggle, setFilterToggle] = useState(false);
  const [watchList, setWatchList] = useState<WatchlistItem[] | []>([]);
  const [loader, setLoader] = useState<boolean>(false)
  const [watchListFilters, setWatchListFilters] = useState<string[]>(watchListFilter);
  const bankUserContext = useContext(BankUserContext);
  const [selectingAllTasks, setSelectingAllTasks] = useState(false);

  useEffect(() => {
    getWatchListData();
  }, [])
  const service = new Service();

  const getWatchListData = () => {
    const watchListData = {
      screen: "prospectTR",
      sections: "watchlist",
      isJsonReturnObject: false,
      userId: bankUserContext.bankuserDetails?.userId,
    };
    service.getWatchListByUserId(watchListData).then((response: AxiosResponse<WatchlistItem[]>) => {
      setWatchList(response.data);
    }).catch((error: AxiosError) => {
      catchError(error, true);
    })
  }

  const removeWatchlist = (list: any) => {

    const final = list.map((element: any) => {
      return element.watchlistId;
    });
    const x = {
      sections: "WatchList",
      watchlistIds: final
    };

    list && list.length > 0 && service.removeWatchList(x).then(() => {

      toast.success("Client removed from Watchlist successfully !")
      getWatchListData();

    }).catch((error: AxiosError) => {
      catchError(error, true);
    });
  };


  const selectAll = () => {
    const updatedWatchList = watchList.map((m) => ({
      ...m,
      selected: !selectingAllTasks,
    }));
    setWatchList(updatedWatchList);
    setSelectingAllTasks(!selectingAllTasks);
  };

  const sortWatchList = (type: string) => {

    if (type === 'edit In Focus') {
      setLoader(true)
      const watchListData = {
        screen: "prospectTR",
        sections: "watchlist",
        isJsonReturnObject: false,
        userId: bankUserContext.bankuserDetails?.userId,
      };
      service.getWatchListByUserId(watchListData).then((response: any) => {
        const updatedWatchlist = response.data?.map((m: any) => ({
          ...m,
          selected: false,
        }));
        setWatchList(updatedWatchlist);
      }).finally(() => setLoader(false));
      setEditMode(true);
      setWatchListFilters(['Remove', 'Cancel']);
      // setLoader(false)
    }
    if (type === 'Remove') {
      const selectedValues = watchList?.filter(
        (m: WatchlistItem) => m.selected === true
      );
      removeWatchlist(selectedValues);
      setWatchListFilters(watchListFilter);
      setEditMode(false);
    }
    if (type === 'Cancel') {
      setWatchListFilters(watchListFilter);
      setEditMode(false);
    }
    if (type == 'sort: a to z') {
      // getWatchListData();
      const sortedAscending = watchList.sort((a, b) => a.companyName.localeCompare(b.companyName));
      setWatchList(sortedAscending);
    }
    if (type == 'sort: z to a') {
      // getWatchListData();
      const sortedAscending = watchList.sort((a, b) => b.companyName.localeCompare(a.companyName));
      setWatchList(sortedAscending);
    }

    if (type == "sort: newest to oldest") {
      const sortedNewToOld = watchList.sort((a, b) => new Date(b.createdDate).valueOf() - new Date(a.createdDate).valueOf());
      setWatchList(sortedNewToOld);
    }

    if (type == "sort: oldest to newest") {
      const sortedNewToOld = watchList.sort((a, b) => new Date(a.createdDate).valueOf() - new Date(b.createdDate).valueOf());
      setWatchList(sortedNewToOld);
    }

  };

  const selectedCheckBox = (e: React.ChangeEvent<HTMLInputElement>, watchlistUuid: string) => {
    const updatedWatchList = watchList.map((m) => {
      if (m.watchlistId === watchlistUuid) {
        return {
          ...m,
          selected: e.target.checked,
        };
      }
      return m;
    });
    setWatchList(updatedWatchList);
  };

  const watchListRedirect = (element: WatchlistItem) => {
    const data = {
      "screen": "redirect",
      "sections": "getProductId",
      "isJsonReturnObject": false,
      "clientId": element.clientId
    }
    service.getClientProductId(data).then((response: AxiosResponse<any>) => {
      const clientProductId = response.data[0].clientProductId
      window.open(`/${element?.redirectUrl}/${element?.clientId}/${clientProductId}`);
    }).catch((error: AxiosError) => {
      catchError(error, true);
    });
  };

  return (
    <div className="watchList">
      {loader ? <FinSpinner /> : <></>}
      <div className="header">
        <span className="headerText">In Focus</span>
        {editMode && (
          <p className="selectAll" onClick={selectAll}>
            Select All
          </p>
        )}
        <Dropdown
          className="dropdownWatchlistFilter"
          toggle={() => setFilterToggle(!filterToggle)}
          isOpen={filterToggle}
        >
          <DropdownToggle
            disabled={watchList.length <= 0}
          >
            {filterToggle ?
              <SettinglinesGold className="inbox_icon" onClick={() => setFilterToggle(!filterToggle)} />
              : (
                <Settinglines onClick={() => setFilterToggle(!filterToggle)} />
              )}
          </DropdownToggle>
          <DropdownMenu right>
            {watchListFilters.map((element, index) => (
              <DropdownItem key={index}>
                <div
                  onClick={() => sortWatchList(element)}
                  style={{ cursor: 'pointer' }}
                  className="text-capitalize item"
                >
                  {element}
                </div>
              </DropdownItem>
            ))}
          </DropdownMenu>
        </Dropdown>
      </div>
      <div className="body">
        {watchList !== undefined && watchList.length > 0 ? (
          <>
            <div className="watchPanel">
              {editMode &&
                watchList.map((element, index) => (
                  <div className="wrap" key={index}>
                    <Input
                      type="checkbox"
                      id={`checkbox${element.watchlistId}`}
                      className="checkbox"
                      onChange={(e) => selectedCheckBox(e, element.watchlistId)}
                      checked={element.selected}
                    />
                    <label htmlFor={`checkbox${element.watchlistId}`}>
                      <span className="watchListElement">
                        <span className="company">
                          {/* {getCompanyLocationNames(element.company_name, element.locationName)} */}
                          {element.companyName}
                        </span>
                      </span>
                    </label>
                  </div>
                ))}
              {!editMode &&
                watchList.map((element, index) => (
                  <div
                    key={index}
                    className="wrap"
                    onClick={() => watchListRedirect(element)}
                  >
                    <span className="watchListElement">
                      <span className="company">
                        {element.companyName}
                      </span>
                    </span>
                  </div>
                ))}
            </div>
          </>
        ) : (
          <p className="noRecordsText">No items in focus list</p>
        )}
      </div>
    </div>
  );
}

export default Focus;
